/* eslint-disable no-restricted-syntax */
import type { AppFeeWaiver } from 'bundles/degree-description/utils/appFeeWaiver';

export enum WaiverType {
  LINK = 'link',
  CODE = 'code',
  EMAIL = 'email',
}

export const appFeeWaiverData: { [slug: string]: AppFeeWaiver } = {
  'ma-education-edtech-lsu-online': {
    waiverType: WaiverType.CODE,
    promoCode: 'GEAUXTIGERS',
    fee: '$50',
    deadline: '12-18-2032',
  },
  'ms-construction-management-lsu-online': {
    waiverType: WaiverType.CODE,
    promoCode: 'GEAUXTIGERS',
    fee: '$50',
    deadline: '12-18-2032',
  },
  'ma-education-higher-education-admin-lsu-online': {
    waiverType: WaiverType.CODE,
    promoCode: 'GEAUXTIGERS',
    fee: '$50',
    deadline: '12-18-2032',
  },
  'ms-analytics-lsu-online': {
    waiverType: WaiverType.CODE,
    promoCode: 'GEAUXTIGERS',
    fee: '$50',
    deadline: '12-18-2032',
  },
  'ms-civil-engineering-lsu-online': {
    waiverType: WaiverType.CODE,
    promoCode: 'GEAUXTIGERS',
    fee: '$50',
    deadline: '12-18-2032',
  },
  'ms-leadership-human-resource-development-lsu-online': {
    waiverType: WaiverType.CODE,
    promoCode: 'GEAUXTIGERS',
    fee: '$50',
    deadline: '12-18-2032',
  },
  'mba-master-business-administration-flores-lsu-online': {
    waiverType: WaiverType.CODE,
    promoCode: 'GEAUXTIGERS',
    fee: '$50',
    deadline: '12-18-2032',
  },
  'msm-digital-transformation-healthcare-northeastern': {
    waiverType: WaiverType.EMAIL,
    email: 'northeastern-msm-dth@coursera.org',
    emailSubject: "Coursera's Northeastern MSM Application Fee Waiver",
    deadline: '12-11-2023',
    availableRegion: ['US', 'CA'],
  },
};

// Used for dev purposes
export const mockAppFeeWaiverData: { [slug: string]: AppFeeWaiver } = {
  imba: {
    waiverType: WaiverType.LINK,
    applicationLink: 'https://google.com',
    deadline: '12-10-2023',
  },
  omie: {
    waiverType: WaiverType.CODE,
    promoCode: 'EOS780',
    fee: '$245',
    availableRegion: ['US', 'CA'],
  },
};
